(function () {
    function BrandCampaignDesignerController() {
    }

    angular
        .module('dashboard')
        .component('brandCampaignDesigner',
            {
                templateUrl: 'components/brand/campaigndesigner/campaigndesigner.9a1c6e10.html',
                bindings: {},
                controller: [ BrandCampaignDesignerController ]
            });
})();
